import { Helmet } from "react-helmet-async";

const SITE = "https://www.energie-tarifberater.de";

export const Seo = ({
  title,
  description,
  path = "/",
  image,
  schema,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} | Energie-Tarifberater`
    : "Energie-Tarifberater | Unabhängige Strom- & Gasberatung";
  const url = `${SITE}${path}`;
  const desc =
    description ||
    "Unabhängige Energieberatung für Strom & Gas. Kostenlose Analyse Ihrer Rechnung – persönlich, transparent, deutschlandweit.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};
